// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2zQbh","bigColWidth":"Table_bigColWidth__3ALRX","biggerColWidth":"Table_biggerColWidth__3eYTM","row":"Table_row__2lIAc","col":"Table_col__UIqpd"};